import Navbar from "../../../component/navbar";
import Footer from "../../../component/footer";
import Fancybox from "../../../component/Fancybox";

export default function PageVL() {
  return (
    <>
      <Navbar />
      <Fancybox
        options={{
          Carousel: {
            infinite: false,
          },
        }}
      >
        <div className="container mx-auto max-w-5xl  px-10 sm:px-20 md:px-0">
          <div className="flex h-full  flex-col gap-4 pt-10 pb-40">
            <div className="md:text-3xl text-xl font-bold text-[#9e76b4]">
              ขั้นตอนการลาเดินทางไปต่างประเทศ (ส่วนตัว)
            </div>
            <div className="md:flex grid grid-cols-1  justify-center items-center gap-4">
              <div
                data-fancybox="gallery"
                href="/VariousLeave/info1.png"
                className="overflow-hidden rounded-md  transition-all duration-300 hover:scale-105 cursor-pointer"
              >
                <img
                  src="/VariousLeave/info1.png"
                  className="object-cover"
                  alt="info1"
                />
              </div>
              <div
                data-fancybox="gallery"
                href="/VariousLeave/info2.png"
                className="overflow-hidden rounded-md  transition-all duration-300 hover:scale-105 cursor-pointer"
              >
                <img
                  src="/VariousLeave/info2.png"
                  className="object-cover"
                  alt="info2"
                />
              </div>
              <div
                data-fancybox="gallery"
                href="/VariousLeave/info3.png"
                className="overflow-hidden rounded-md  transition-all duration-300 hover:scale-105 cursor-pointer"
              >
                <img
                  src="/VariousLeave/info3.png"
                  className="object-cover"
                  alt="info3"
                />
              </div>
            </div>

            <div className="flex flex-col gap-4">
              <div className="md:text-3xl text-xl font-bold text-[#9e76b4]">
                Ex.การลาเดินทางไปต่างประเทศ (ส่วนตัว)
              </div>
              <div className="flex flex-col gap-4">
                <div
                  onClick={() =>
                    window.open(
                      "/VariousLeave/from_download/แบบฟอร์มการลาไปต่างประเทศ ลาพักผ่อน ลากิจ.doc"
                    )
                  }
                  className="bg-[#9e76b4] text-white w-full px-2 py-1 rounded-lg 
                  justify-center items-center flex md:text-2xl text-xl font-bold
                  hover:bg-[#9e76b4]/60 transition-all duration-300 cursor-pointer
                  "
                >
                  Download บันทึกการลาเดินทางไปต่างประเทศ
                </div>
                <div
                  data-fancybox="gallery"
                  href="/VariousLeave/from_download/Ex-0001.jpg"
                  className="overflow-hidden rounded-md   cursor-pointer relative"
                >
                  <img
                    src="/VariousLeave/from_download/Ex-0001.jpg"
                    className="object-cover w-full transition-all duration-300 hover:shadow-lg"
                    alt="info3"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fancybox>
      <Footer />
    </>
  );
}
